module.exports = __webpack_public_path__ + "img/chest.0bdca377.png";